// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import LoginPage from './pages/LoginPage';
import SubscribePage from './pages/SubscribePage';
import AdminPage from './pages/AdminPage';
import './App.css'; // Import the global CSS

function AppContent() {
    const location = useLocation();
    const isBillingFlow = ['/dashboard', '/subscribe', '/admin'].includes(location.pathname);

    return (
        <div className="app">
            {!isBillingFlow && <Header />}
            <main className="main-content">
                <Routes>
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/dashboard" element={<SubscribePage />} />
                    <Route path="/subscribe" element={<SubscribePage />} />
                </Routes>
            </main>
            {!isBillingFlow && <Footer />}
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
